import { configureStore } from '@reduxjs/toolkit';
import factsReducer from './slices/factsSlice';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import categoriesReducer from './slices/categoriesSlice';

export const store = configureStore({
  reducer: {
    facts: factsReducer,
    auth: authReducer,
    user: userReducer,
    categories: categoriesReducer, // 添加這行
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
